import React from 'react'
import { Note } from '@myxplor/ui'
import { FormInput } from '@myxplor/forms'

export const ReportEmailAddress = ({ value, errors, onChange, reportLabel }) => (
  <Note important>
    The {reportLabel} may take several minutes to generate, so we will email you once it is ready.
    <FormInput
      name="email_address"
      label="Email Address"
      type="email"
      value={value}
      errors={errors}
      onChange={onChange}
      required
      hint="This needs to be an email address you have access to"
    />
  </Note>
)



// WEBPACK FOOTER //
// ./src/provider-level/reports/reports/_email.jsx